import React, { useState } from "react";
import "./tabsSectionInternal.scss";
import Slider from "react-slick";
import SpotifyListen from "../../atoms/spotify-listen/spotifyListen";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import GlobalContext from "../../../contexts/globalContext";
import FooterRatesTabsInternal from "../../atoms/footer-tabs-rates-internal/footer-tabs-rates-internal";
import FooterRatesTabs from "../../atoms/footer-tabs-rates/footer-tabs-rates";
import { normalizeTwoWords } from "../../../shared/utils/stringUtilities";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import Button from "../../atoms/button/button";
import { navigate } from "gatsby";

let showSlider = [1.3];
const TabsSectionInternal = (props: ReferenciaContenido) => {
  const { location } = props;
  const datas = Object.values(location ? location : { key: 0 });
  const [activeItem, setActiveItem] = useState(
    datas.length > 1 ? location.ancla : 0
  );
  //const [activeItem, setActiveItem] = useState(0);
  const data = props;
  const settings = {
    focusOnSelect: true,
    infinite: false,
    slidesToShow: showSlider[0],
    slidesToScroll: 1,
    speed: 500,
    initialSlide: activeItem,
    dots: false,
    variableWidth: true,
  };

  //console.log(data);

  return (
    <GlobalContext.Consumer>
      {(dataContext) => (
        <div className="m-tabs-sec-internal ">
          <div className="container-tabs">
            <h2 className="m-tabs-sec-internal__title title-secondary">
              {data.tituloGeneral}
            </h2>
            <div className="m-tabs-sec-internal__cont">
              <div className="m-tabs-sec-internal__tabs scroll1 hide-on-mobile">
                <ul>
                  {data &&
                    data.referenciaTabsContenido.map((tab, i) => (
                      <li key={`tab${i}`} className={``}>
                        <button
                          className={`gtmRedDeAmorMenuHabitosSaludMental${normalizeTwoWords(
                            tab.nombreTab
                          )}   m-tabs-sec-internal__tabs-btn ${
                            activeItem === i
                              ? "m-tabs-sec-internal__tabs-btn--active"
                              : ""
                          } ${
                            i === 0 || i === 1
                              ? "m-tabs-sec-internal__tabs-btn-large"
                              : ""
                          } ${
                            (activeItem === i && i === 0) ||
                            (activeItem === i && i === 1)
                              ? "m-tabs-sec-internal__tabs-btn--active-large"
                              : ""
                          }`}
                          onClick={() => {
                            setActiveItem(i);
                          }}
                        >
                          {tab.nombreTab}
                        </button>
                      </li>
                    ))}
                </ul>
              </div>
              <div className="show-on-mobile">
                <div className="m-tabs-sec-internal__tabs ">
                  <Slider {...settings}>
                    {data &&
                      data.referenciaTabsContenido.map((tab, i) => (
                        <div
                          className={`m-tabs-sec-internal__tabs__mobile__internal `}
                          key={"m" + i}
                        >
                          <div>
                            <button
                              className={`m-tabs-sec-internal__tabs-btn ${
                                activeItem === i
                                  ? "m-tabs-sec-internal__tabs-btn--active"
                                  : ""
                              } `}
                              onClick={() => {
                                setActiveItem(i);
                              }}
                            >
                              {tab.nombreTab}
                            </button>
                          </div>
                        </div>
                      ))}
                  </Slider>
                </div>
              </div>
              <div className="m-tabs-sec-internal__container">
                <div className="m-tabs-sec-internal__details">
                  <div className="m-tabs-sec-internal__details-section1">
                    <p className="m-tabs-sec-internal__details-section1-description">
                      {documentToReactComponents(
                        JSON.parse(
                          data?.referenciaTabsContenido?.[activeItem]
                            ?.descripcion?.raw
                        )
                      )}
                    </p>
                    <Button
                      text={
                        data.referenciaTabsContenido[activeItem]
                          ?.referenciaTarifas?.tituloBoton
                      }
                      classname={`secondary button-large`}
                      type={
                        data.nombreCategoria === "Interna formación"
                          ? "link"
                          : "button"
                      }
                      isDisabled={false}
                      strictCss={false}
                      href={
                        "https://tiendaempresas.comfama.com/comfamab2b/es/Portafolio-Empresarial/Red-de-amor/c/B_RED_DE_AMOR"
                      }
                      onClickAction={() => {
                        //console.log(data.referenciaTabsContenido[activeItem].autorLibro)
                        if (
                          data.referenciaTabsContenido[activeItem].autorLibro
                        ) {
                          localStorage.setItem(
                            "selected-service-id",
                            data.referenciaTabsContenido[activeItem].autorLibro
                          );
                        }
                        dataContext.gigyaContext.gigyaAccount
                          ? navigate("/agenda-red-de-amor")
                          : dataContext.gigyaContext.login();
                      }}
                    />
                  </div>
                  {data.nombreCategoria !== "Interna formación" ? (
                    <div className="m-tabs-sec-internal__details-section2">
                      <a
                        href={
                          data.referenciaTabsContenido[activeItem]
                            .referenciaCursosDestacados[0]?.redireccionBoton
                        }
                      >
                        <div className="m-tabs-sec-internal__details-section2-article">
                          <img
                            className="m-tabs-sec-internal__details-section2-article-imagen"
                            src={
                              data.referenciaTabsContenido[activeItem]
                                .referenciaCursosDestacados[0].imagenPrincipal
                                .gatsbyImageData
                            }
                            alt="figura-habitos"
                          />
                          <span className="m-tabs-sec-internal__details-section2-article-ship">
                            {
                              data.referenciaTabsContenido[activeItem]
                                .referenciaCursosDestacados[0].textoBoton
                            }
                          </span>
                          <p className="m-tabs-sec-internal__details-section2-article-details">
                            {
                              data.referenciaTabsContenido[activeItem]
                                .referenciaCursosDestacados[0].tituloPrincipal
                            }
                          </p>
                        </div>
                      </a>
                      <SpotifyListen
                        link={
                          data.referenciaTabsContenido[activeItem]
                            .referenciaCursosDestacados[1].redireccionBoton
                        }
                      />
                      <iframe
                        className="video"
                        src={
                          data.referenciaTabsContenido[activeItem]
                            .referenciaCursosDestacados[2].redireccionBoton
                        }
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      ></iframe>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="m-tabs-sec-internal__footer">
                  {data.referenciaTabsContenido[activeItem].referenciaTarifas
                    ?.tarifas ? (
                    <FooterRatesTabs
                      tabsSectionRatesData={data}
                      activeItem={activeItem}
                    />
                  ) : (
                    <FooterRatesTabsInternal
                      tabsSectionRatesData={data}
                      activeItem={activeItem}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </GlobalContext.Consumer>
  );
};

export default TabsSectionInternal;
